import * as React from 'react';

export class CloudHubMuleSvg extends React.Component<{}> {

  render() {
    return (
      <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          xmlSpace="preserve"
      >
        <g id="Layer_3"/>
        <g id="Layer_1">
          <path
              className="st0"
              fill="#D7D8D9"
              d="M35.2,3.3C35.2,3.3,35.1,3.2,35.2,3.3C35.1,3.2,35.2,3.3,35.2,3.3L35.2,3.3z"
          />
          <g>
            <g>
              <g>
                <g>
                  <g>

                    <ellipse
                        transform="matrix(2.056655e-02 -0.9998 0.9998 2.056655e-02 -0.5089 49.4805)"
                        className="st1"
                        fill="#112D4F"
                        cx="25"
                        cy="25"
                        rx="24"
                        ry="24"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g>
            <path
                className="st2"
                fill="#59C7E7"
                d="M28.8,34.9c-2.9-0.1-5.4,2-5.8,4.8l-8.8-0.4c-0.2-0.5-0.4-1-0.7-1.5l7.6-7c0.8,0.5,1.8,0.9,2.9,0.9c3.1,0.1,5.7-2.3,
                5.8-5.4c0.1-3.1-2.3-5.7-5.4-5.8c-3.1-0.1-5.7,2.3-5.8,5.4c-0.1,1.2,0.3,2.4,1,3.4L12,36.2c-0.6-0.4-1.2-0.8-1.9-1.1l0.4-9.6c2.7-0.3,
                4.9-2.5,5-5.3c0.1-3.1-2.3-5.7-5.4-5.8s-5.7,2.3-5.8,5.4c-0.1,2.6,1.6,4.9,4,5.6L8,34.7c-1.7-0.1-3.1,0.4-4.4,1.4l1.1,1.8l0.4-0.3l-0.2,
                0.1c0.5-0.4,1.3-0.8,2-0.9c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0,0.5,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c2.7,0.1,4.7,2.4,
                4.6,5c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.3-0.1,0.4c0,0,0,0,0,0c-0.1,0.5-0.7,1.7-0.9,2.1l0,0l0,
                0l1.7,1.1c0.7-1,1.4-2.7,1.4-4.1c0-0.1,0-0.3,0-0.4l8.5,0.4c0.6,2.3,2.7,4.1,5.2,4.2c3.1,0.1,5.7-2.3,5.8-5.4S31.9,35,28.8,34.9z M24.3,
                22.3c2.2,0.1,3.9,1.9,3.8,4.1c-0.1,2.2-1.9,3.9-4.1,3.8c-2.2-0.1-3.9-1.9-3.8-4.1C20.3,23.9,22.2,22.2,24.3,22.3z M6,19.8c0.1-2.2,
                1.9-3.9,4.1-3.8c2.2,0.1,3.9,1.9,3.8,4.1c-0.1,2.2-1.9,3.9-4.1,3.8S5.9,22,6,19.8z M28.4,44.4c-2.2-0.1-3.9-1.9-3.8-4.1c0.1-2.2,1.9-3.9,
                4.1-3.8s3.9,1.9,3.8,4.1C32.4,42.8,30.6,44.5,28.4,44.4z"
            />
          </g>
        </g>
        <g id="Layer_2"/>
      </svg>
    )
  }
}